import { setWizards } from 'core/components/wizard/actions'

export const activateStep = (wizards, hash) => {
  const stepsActive = wizards[wizards.activeWizard]
  const nextIndex = stepsActive.findIndex(step => step.hash === hash) + 1
  return setWizards({
    ...wizards,
    aStepsTradeIn: Object.assign(stepsActive, {
      [nextIndex]: { ...stepsActive[nextIndex], isActive: true }
    })
  })
}

export const deactivateStep = (wizards, hash) => {
  const stepsActive = wizards[wizards.activeWizard]
  const nextIndex = stepsActive.findIndex(step => step.hash === hash) + 1
  return setWizards({
    ...wizards,
    aStepsTradeIn: Object.assign(stepsActive, {
      [nextIndex]: { ...stepsActive[nextIndex], isActive: false }
    })
  })
}
